import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { RoleService } from 'src/app/services/role/role.service';
import { Role } from 'src/app/model/role/role.model';
import { Roleassign } from 'src/app/model/role/roleassign.model';
import { NgForm } from '@angular/forms';
import { RoleguardServiceGuard } from 'src/app/auth/roleguard-service.guard';
import { Userobjects } from 'src/app/model/role/userobjects.model';
//import { Userobjects } from 'src/app/model/pvr/userobjects.model';
//import swal from 'sweetalert';
import { Roledata } from 'src/app/model/role/roledata.model';


@Component({
  selector: 'app-viewrole',
  templateUrl: './viewrole.component.html',
  styleUrls: ['./viewrole.component.css']
})
export class ViewroleComponent implements OnInit {
  data: Userobjects[];
  roles: Roleassign[];
  role: Roleassign;
  name: string;
  description: string;
  roleId: number;
  dataAny:any;

  // test: boolean = true;

  roledata: Roledata;

  //data1:Role;

  //constructor(private tendringservice:TenderingService) { }
  constructor(private roleservice: RoleService, private route: ActivatedRoute,private router:Router) {
    // this.roleId = this.route.snapshot.params.roleid;
    this.roleId = this.route.snapshot.params.id;

  }

  ngOnInit() {

    //this.role = new Roleassign();
    this.getViewUserRole();
    this.roledata=new Roledata();
    this.getRoleHeading();


    //this.getViewUserRole();
    //this.getUserRoles();
  }
  getRoleHeading()
  {
    this.roleservice.getRoleHeading(this.roleId).subscribe(
      (data: any) => {
        debugger;

        this.dataAny = data;
        this.roledata=this.dataAny
          console.log(data);
      })

  }
  getViewUserRole() {

    this.roleservice.getViewUserRole(this.roleId).subscribe(
      (data: any) => {
        debugger;

        this.data = data;

        console.log(data);
         if (this.data != null) {
            this.name=this.data[0].name;
            this.description=this.data[0].roleDescription;
        }

      }

    )
  }


  alertNew() {
    //swal("hello Its the part of that");


  }

  //testing
  doSomething() {
    console.log;
    alert("testing purpose");
  }
  OnClick(id: number) {
    //debugger;
    //alert(id);
    var element = <HTMLInputElement>document.getElementById("update" + id);

    var isChecked = element.checked;
    if (isChecked) {
      var element = <HTMLInputElement>document.getElementById("read" + id);
      element.checked = true;
      this.data[id].read = true;
    }
  }
  SubmitForm(form: NgForm) {

    console.log(form.value);
    console.log(this.data);
    // for(var i=0; i<this.data.length;i++)
    // {
    //   this.data[i].roleDescription =
    // }
    this.data[0].id = this.roleId;
    this.roleservice.updaterole(this.data).subscribe(
      data => {
        if (data == true) {
          alert("updated");
          this.getViewUserRole();
          console.log(data);
        }
        else {
          alert("An error occured");
        }

      }

    )
  }
  back()
  {
    this.router.navigate(['/userrole']);
  }


}


